import { CastAndCrewMemberRole } from '@vista-digital/ocapi-types/v1';
import { getCastAndCrewMembersByIds } from '@vista-digital/occ-domain';
import { hasTemplateParam } from './display-text-utils';
export const getActorsForFilm = (film) => {
    return getCastAndCrewForRole(film.castAndCrew, CastAndCrewMemberRole.Actor);
};
export const getDirectorsForFilm = (film) => {
    return getCastAndCrewForRole(film.castAndCrew, CastAndCrewMemberRole.Director);
};
const getCastAndCrewForRole = (members, role) => {
    const memberIds = members.reduce((acc, member) => {
        if (member.roles.includes(role))
            acc.push(member.castAndCrewMemberId);
        return acc;
    }, []);
    return getCastAndCrewMembersByIds(memberIds);
};
export const getFormattedCastAndCrewMembersString = (members, i18n) => {
    return i18n.personNameList(members.map(member => member.name));
};
export const formatFilmRuntime = (runtimeInMinutes, displayText, i18n) => {
    const { runtimeFormat } = displayText;
    if (!hasTemplateParam(runtimeFormat, 'hours')) {
        return i18n.template(runtimeFormat, { minutes: runtimeInMinutes });
    }
    return i18n.template(runtimeFormat, {
        hours: Math.floor(runtimeInMinutes / 60),
        minutes: runtimeInMinutes % 60
    });
};
//# sourceMappingURL=film-utils.js.map